<template>
  <b-card class="bg-light text-center mt-2 mb-2">
    <blockquote class="card-blockquote">
      <slot name="body">
        <p class="mt-2" v-if="values && values.text">{{ values.text }}</p>
        <p class="mt-2" v-else>{{ $t('global.empty_data_text') }}</p>
      </slot>
    </blockquote>
  </b-card>
</template>
<script>
export default {
  props: {
    values: {
      type: Object,
      required: false
    },
  },
};
</script>
